<template>
  <div>
    <div class="all-left-top-box">
      <div class = "e-title-box">
        当前数据时间:  {{this.deviceData.proDataTime}}
      </div>

      <a-row  :gutter="[16,8]" class="ael-card-all-box" >

        <a-col :span="6"  v-for="item in deviceData.events" :key="item.ID">
          <a-card class="ael-top-card-single">
            <div class="e-alarm-title">{{item.eventName}}</div>
            <div class="e-card-single-box">
              <img :src="item.cIcon" alt="" class="e-img-wh">
              <div class="e-card-text-box" >
                <div class="ael-content-text-box" v-for="pdata in item.outputData2">
                  <div class="ael-line-height ael-content-name-box">错误代码:{{pdata.name}}</div>
                  <div class="ael-line-height ">报警值：<span class="e-alarm-red-text">{{pdata.dataValue}}</span></div>
                </div>
                <div class="ael-content-a-box">
                  <a-button type="link" class="ael-content-a" @click="showModal(item.outputData)">
                    更多
                  </a-button>
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :offset="23" :span="1"><a-button type="link">更多</a-button></a-col>
      </a-row>
    </div>
    <a-modal
      title="详情"
      :visible="aelModalVisible"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="确定"
    >
      <div v-for="item in outputDetail">
        <div>错误代码:{{item.name}}</div>
        <div>报警值：{{item.dataValue}}</div>
        <div>时间：{{item.timeDes}}</div>
        <a-divider />
      </div>



    </a-modal>

    <a-card class="all-card-style ">
      <!--      筛选条件-->
      <div class="search-box">
        <a-form layout="inline" :form="form" @submit="">

          <a-form-item
            label="展现形式" class="ant-form-item2"
          >
            <a-button-group>
              <a-button @click="showLine">曲线</a-button>
              <a-button @click="showTable">表格</a-button>
            </a-button-group>
          </a-form-item>

          <a-form-item
            label="起止日期" class="ant-form-item2"
          >
            <a-range-picker
              :default-value="[deviceData.queryInfoList.startDate, deviceData.queryInfoList.endDate]"
              @change="dateSelect"
            />
          </a-form-item>

          <a-form-item>
            <a-select :value="proSelectItem.value" style="width: 120px" @change="proSelect" class="ant-form-item2">

              <a-select-option v-for="(item,index) in proSelectItems" :key="item.key" :value="index">
                {{item.value}}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-select default-value="实时曲线" style="width: 120px" class="ant-form-item2">
              <a-select-option value="1">
                实时曲线
              </a-select-option>
              <!-- <a-select-option value="2">
                历史曲线
              </a-select-option> -->
              <a-select-option value="3">
                早均线
              </a-select-option>
              <a-select-option value="4">
                晚均线
              </a-select-option>
              <a-select-option value="5">
                日均线
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="submit" @click="search">
              查询
            </a-button>
            <span class="button-margin"></span>
            <a-button html-type="submit" >
              导出
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--      曲线-->
      <div  v-show="lineVisible">
        <div id="c1"></div>
      </div>

      <!--      表格-->
      <div v-if="tableVisible">
        <!-- <a-table :columns="columns" :data-source="data"></a-table> -->
        <a-table :columns="columns" :data-source="deviceData.dataList"></a-table>
      </div>
    </a-card>
  </div>
</template>
<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { Chart } from '@antv/g2';
  import { _getDeviceEventData } from '@/common/request.js'

  const columns = [

    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '原始值',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  const data = [
    {
      key: '1',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
    {
      key: '2',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
    {
      key: '3',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },

    {
      key: '4',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },

    {
      key: '5',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
  ];

  const data2 = [
    { year: '1991', value: 3 },
    { year: '1992', value: 4 },
    { year: '1993', value: 3.5 },
    { year: '1994', value: 5 },
    { year: '1995', value: 4.9 },
    { year: '1996', value: 6 },
    { year: '1997', value: 7 },
    { year: '1998', value: 9 },
    { year: '1999', value: 13 },
  ];

  export default {
    name: 'alarmEventsList',
    components: {

    },
    data() {
      return {
        form: this.$form.createForm(this),
        lineVisible:true,
        tableVisible:false,
        aelModalVisible:false,
        columns,
        data,
        data2,
        chart: {},
        proSelectItems:[],
        proSelectItem:{
          key:"",
          value:""
        },
        deviceData:{
          queryInfo:{
            productkey:"",
            devicename:"",
            limit:1
          },
          queryInfoList:{
            productkey:"",
            devicename:"",
            identifier:"",
            valueidentifier:"DevPwrOff",
            startDate:'1900-01-01',
            endDate:'1900-01-01',
            page:0,
            limit:0
          },
          devices:{},
          proDataTime:"",
          events:[],
          dataList:[],
          timer: '',//定时器
          timerList:''
        },
        outputDetail:[]
      }
    },
    created(){

      init1();
    },
    mounted() {
      this.createLine()
    },
    methods:{
      async init1(){
        this.deviceData.queryInfoList.startDate=this.utils.getDate()
        this.deviceData.queryInfoList.endDate=this.utils.getDate('nextday')
        this.IotId=this.$route.query.IotId





        let res = await this.$http.post('WLWDevice/List', {
          sceneId: this.$store.getters.SCene.ID  ,cSystemCode:'节水灌溉',
          cEntID:this.$store.getters.User.enterprise.ID
        })
        var device=res.data.obj.list;
        device=device.filter(x=>x.IotId==this.IotId)[0]
        if(device!=null) this.deviceData.devices=device







        var ThingModel=this.$store.getters.ThingModels.filter(x=>x.productKey==this.deviceData.devices.ProductKey)[0]
        if(ThingModel!=null) {
          this.deviceData.events=this.utils.deepClone(ThingModel.events)
          this.deviceData.events.forEach(element=>{
            var item={
              key:element.identifier,
              value:element.eventName
            }
            this.proSelectItems.push(item)
          })
          if(this.proSelectItems.length>0) {
            this.proSelectItem=this.proSelectItems[0]
            this.deviceData.queryInfoList.identifier=this.proSelectItem.key
          }
        }

        this.deviceData.queryInfo.productkey=this.deviceData.devices.ProductKey
        this.deviceData.queryInfo.devicename=this.deviceData.devices.DeviceName
        this.deviceData.queryInfoList.productkey=this.deviceData.devices.ProductKey
        this.deviceData.queryInfoList.devicename=this.deviceData.devices.DeviceName

        this.getDeviceEventData()
        this.getDeviceEventListData()

      },
      showModal(record){
        this.outputDetail=record
        this.aelModalVisible=true
      },
      handleCancel:function(){
        this.aelModalVisible=false
      },
      handleOk:function(){
        this.aelModalVisible=false
      },
      showLine:function(){
        this.lineVisible=true;
        this.tableVisible=false;
        // this.reloadDrawing()

      },
      showTable:function () {
        // this.reloadDrawing();

        this.lineVisible=false;
        this.tableVisible=true;

      },
      createLine:function(){
        // Step 1: 创建 Chart 对象
        this.chart = new Chart({
          container: 'c1',
          autoFit: true,
          width: 800,
          height: 500,
          padding:[30, 100, 30, 40],
        });

        // Step 2: 载入数据源
        //this.chart.data(data2);
        this.chart.data(this.deviceData.dataList);
        // Step 3：创建图形语法，绘制柱状图
        // this.chart.interval().position('genre*sold');
        this.chart.scale({
          time: {
            range: [0.05, 0.95],
            type: 'time',
            mask: 'MM-DD hh:mm:ss',
          },
          value: {
            min: 0,
            nice: true,
          },
        });
        this.chart.tooltip({
          showCrosshairs: true, // 展示 Tooltip 辅助线
          shared: true,
        });
        this.chart.line().position('time*value').label('value');
        this.chart.point().position('time*value');

        // Step 4: 渲染图表
        this.chart.render();
      },

      reloadDrawing:function() {
        //销毁画布对象
        this.chart.destroy();
        //重新调用数据进行加载
        this.createLine();
      },
      async getDeviceEventData(){
        var res =await _getDeviceEventData(this,this.deviceData.queryInfo)
        if(res !=null ){
          var data=res.obj.list
          if(data!=null && data.length>0)
          {
            this.deviceData.proDataTime=data[0].timeDes
            this.deviceData.events.forEach(element => {
              let src='';
              if (element.cIcon){
                src=element.cIcon;
              }else {
                src="../../../../img/ktouer.png"
              }
              element.cIcon=src;
              var dataItems=data.filter(x=>x.identifier== element.identifier)
              if(dataItems!=null && dataItems.length>0){
                var dataItem=dataItems[0].values

                element.outputData.forEach(elementItem=>{
                  var value=dataItem[elementItem.identifier]
                  this.$set(elementItem,"dataValue",value)
                  this.$set(elementItem,"timeDes",dataItems[0].timeDes)
                })
              }
              else{
                element.outputData.forEach(elementItem=>{
                  this.$set(elementItem,"dataValue",0)
                  this.$set(elementItem,"timeDes","")
                })
              }
              let outputData2=[];
              if (element.outputData&&element.outputData.length>2){
                outputData2=element.outputData.slice(0,2)
              }else {
                outputData2=element.outputData;
              }
              this.$set(element,"outputData2",outputData2)
            })
          }
          else{
            this.deviceData.events.forEach(element => {
              element.outputData.forEach(elementItem=>{
                this.$set(elementItem,"dataValue",0)
                this.$set(elementItem,"timeDes",'')
              })
              let outputData2=[];
              if (element.outputData&&element.outputData.length>2){
                outputData2=element.outputData.slice(0,2)
              }else {
                outputData2=element.outputData;
              }
              this.$set(element,"outputData2",outputData2)
            })
          }


        }
        else{
          this.$message.error(res.message);
        }
      },
      async getDeviceEventListData(){
        var res=await _getDeviceEventData(this,this.deviceData.queryInfoList)
        if(res !=null ){
          var data=res.obj.list
          if(data!=null && data.length>0)
          {
            this.deviceData.dataList.splice(0)
            data.forEach(element => {
              var item={
                time:element.timeDes,
                value:this.utils.formatNumber1(element.values[this.deviceData.queryInfoList.valueidentifier])
              }
              this.deviceData.dataList.push(item)
            })
            this.chart.render();
          }
          else{

          }
        }
        else{
          this.$message.error(res.message);
        }
      },
      dateSelect(date, dateString){
        this.deviceData.queryInfoList.startDate=dateString[0]
        this.deviceData.queryInfoList.endDate=dateString[1]
      },
      proSelect(value,opt){
        this.proSelectItem=this.proSelectItems[value]
      },
      search(){
        this.deviceData.queryInfoList.identifier=this.proSelectItem.key
        this.getDevicePropListData()
      }
    },


  }
</script>

<style>
  @import "../equipmentDetailsStyle.css";

  .ael-card-all-box{
    display: flex;
    flex-wrap: wrap;
    align-items:stretch
  }

  .ael-top-card-single{
    height: 100%;
  }

  .ael-content-text-box{
    display: flex;
    /*flex-direction: column;*/
    justify-content: space-around;
    align-items: center;
    vertical-align:text-bottom;
  }



  .ael-content-all-box{
    display: flex;
    flex-direction: column;
  }

  .ael-line-height{
    line-height: 35px;
    vertical-align:top;
    margin-right: 15px;

  }
  .ael-content-name-box{
    width: 39%;
    /*border: 1px solid #000000;*/
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .ael-content-a{
    padding: 0;
    background: none !important;
    border: none !important;
  }
</style>


